import { render } from "./DiligenceLayout.vue?vue&type=template&id=6c565331"
import script from "./DiligenceLayout.vue?vue&type=script&lang=js"
export * from "./DiligenceLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__